export const translations = {
  en: {
    common: {
      save: 'Save',
      cancel: 'Cancel',
      confirm: 'Confirm',
      loading: 'Loading...',
      retry: 'Retry',
      back: 'Back',
      done: 'Done',
      edit: 'Edit',
      delete: 'Delete',
      selected: 'Selected',
      seeAll: 'See all',
      viewAll: 'View all',
      search: 'Search',
      error: 'Error',
      success: 'Success',
      close: 'Close',
      submit: 'Submit',
      all: 'All',
      status: 'Status',
      active: 'Active',
      inactive: 'Inactive',
      call: 'Call',
      share: 'Share',
      refresh: 'Refresh',
      details: 'Details',
      mins: 'mins',
      today: 'Today',
      remove: 'Remove',
      apply: 'Apply',
      reset: 'Reset',
      bookNow: 'Book Now',
    },
    tabs: {
      home: 'Home',
      discover: 'Discover',
      bookings: 'Bookings',
      favorites: 'Favorites',
      profile: 'Profile',
    },
    home: {
      greetingMorning: 'Good morning',
      greetingAfternoon: 'Good afternoon',
      greetingEvening: 'Good evening',
      searchPlaceholder: 'Search salons, stylists, haircuts...',
      yourNextAppt: 'Your Next Appointment',
      yourUpcomingAppt: 'Your Upcoming Appointment',
      moreAppts: 'more',
      inviteFriends: 'Bring your friends',
      inviteFriendsBadge: 'INVITE FRIENDS',
      inviteFriendsSub: 'Share SalunBD so your friends can find a stylist and book in a few taps.',
      inviteFriendsBtn: 'Invite Friends',
      nearbyShops: 'Nearby Salons',
      findingSalons: 'Finding salons near you…',
      loadErrorTitle: "Couldn't load shops",
      loadErrorMsg: 'Check your connection and try again.',
      noShopsTitle: 'No shops listed yet',
      noShopsMsg: 'Check back soon — new shops are joining SalunBD.',
      nearbyNeedsLocation: 'See shops near you',
      nearbyNeedsLocationMsg: 'Allow location when asked, or pick a place with the location button at the top, to see stylists and salons near you.',
      noNearbyTitle: 'No shops near you yet',
      noNearbyMsg: 'Nothing within 25 km yet. You can still browse every shop.',
      howWasVisit: 'How was your visit?',
      timeToComeBack: 'Time to come back',
      bookAgain: 'Book Again',
      unreadMessages: 'Messages',
      unreadAlerts: 'Notifications',
    },
    discover: {
      title: 'Discover Salons',
      searchPlaceholder: 'Search salons, services, or stylists...',
      quickFilterAll: 'All Salons',
      quickFilterTopRated: 'Top Rated (4.5★+)',
      quickFilterInstant: 'Instant Booking',
      nearbyHeading: 'Nearby Salons',
      enableLocation: 'Enable Location',
      enableLocationSub: 'Turn on device location to see shops nearest to you.',
      findingNearby: 'Finding salons near you…',
      noNearbyTitle: 'No shops found nearby',
      noNearbySub: 'Try adjusting your location or explore top rated.',
      popularHeading: 'Popular on SalunBD',
      popularNearHeading: 'Popular near you',
      popularSub: 'Busiest and best reviewed this month',
      salonsHeading: 'Salons & Spas',
      loadingSalons: 'Loading salons & spas…',
      salonsError: "Couldn't load salons & spas",
      withinKm: 'Within {km} km of you',
      closestToYou: 'Closest to you first',
      closestTo: 'Closest to {place} first',
      browseAll: 'Browse all shops',
      noNearbyWithin: 'No shops or stylists listed yet. New ones are joining SalunBD.',
      recommendedHeading: 'Recommended for you',
      topStylistsHeading: 'Top Rated Stylists',
      offersHeading: 'Active Deals & Offers',
      seeAll: 'See all',
    },
    bookings: {
      title: 'My Bookings',
      searchPlaceholder: 'Search salon, stylist, or booking code...',
      filterAll: 'All',
      filterUpcoming: 'Upcoming',
      filterCompleted: 'Completed',
      filterCancelled: 'Cancelled',
      emptyUpcomingTitle: 'No upcoming appointments',
      emptyUpcomingSub: 'Book your next grooming session in a few taps.',
      emptyCompletedTitle: 'No completed visits yet',
      emptyCompletedSub: 'Your grooming history will show up here.',
      emptyCancelledTitle: 'No cancelled bookings',
      emptyCancelledSub: 'You have no cancelled appointments.',
      emptyAllTitle: 'No bookings yet',
      emptyAllSub: 'Browse top salons and schedule an appointment.',
      bookNow: 'Book Appointment',
      cancelBooking: 'Cancel Booking',
      cancelConfirmTitle: 'Cancel this booking?',
      cancelConfirmMsg: 'Are you sure you want to cancel this appointment?',
      reschedule: 'Reschedule',
      viewShop: 'View Salon',
      statusUpcoming: 'Upcoming',
      statusCompleted: 'Completed',
      statusCancelled: 'Cancelled',
      statusInQueue: 'In Queue',
      statusInChair: 'In Chair',
      bookingCode: 'Booking Code',
    },
    favorites: {
      title: 'Saved Favorites',
      shopsTab: 'Shops',
      stylistsTab: 'Stylists',
      emptyShopsTitle: 'No saved shops',
      emptyShopsSub: 'Tap the heart on any shop to save it here for fast booking.',
      emptyStylistsTitle: 'No saved stylists',
      emptyStylistsSub: 'Tap the heart on a stylist profile to find them easily.',
      exploreShops: 'Explore Salons',
      loadingShop: 'Loading shop…',
      loadingStylist: 'Loading stylist…',
      errorShop: "Couldn't load this shop",
      errorStylist: "Couldn't load this stylist",
    },
    loyalty: {
      title: 'Rewards & Loyalty',
      points: 'Points',
      tierMember: 'Member',
      tierSilver: 'Silver',
      tierGold: 'Gold',
      tierPlatinum: 'Platinum',
      perksTitle: 'Your Benefits',
      historyTitle: 'Points Activity',
      currentTier: 'Current Tier',
      activities: 'Activities',
      howToEarn: 'How to Earn Points',
      bookAnyService: 'Book Any Service',
      emptyActivityTitle: 'No loyalty activity yet',
      emptyActivitySub: 'Book services or invite friends to begin earning loyalty points!',
      loading: 'Loading loyalty program',
      loadError: 'Could not load loyalty rewards',
    },
    services: {
      haircut: 'Haircut',
      beard: 'Beard Trim',
      facial: 'Facial & Spa',
      color: 'Hair Color',
      styling: 'Styling',
    },
    settings: {
      title: 'Settings',
      preferences: 'Preferences',
      notifications: 'Notifications',
      notificationsSubtitle: 'Choose which alerts you want to get',
      appearance: 'Appearance & Language',
      appearanceSubtitle: 'Theme and app language',
      security: 'Security & Privacy',
      securitySubtitle: 'Password, biometric sign-in, and devices',
      support: 'Help & Support',
      supportSubtitle: 'FAQs, contact support, and tickets',
      privacyPolicy: 'Privacy Policy',
      privacyPolicySubtitle: 'How SalunBD handles your data',
      termsOfService: 'Terms of Service',
      termsOfServiceSubtitle: 'The rules for using SalunBD',
    },
    appearance: {
      title: 'Appearance & Language',
      subtitle: 'Personalize SalunBD on this device.',
      themeSection: 'Theme',
      useDevice: 'Use device setting',
      useDeviceSub: 'Follow the phone appearance',
      light: 'Light',
      lightSub: 'Bright interface',
      dark: 'Dark',
      darkSub: 'Reduced brightness',
      languageSection: 'Language',
      english: 'English',
      englishSub: 'Application language',
      bangla: 'বাংলা',
      banglaSub: 'অ্যাপ্লিকেশনের ভাষা',
      banner: 'Your language choice is saved. Changing it updates the app instantly.',
    },
    profile: {
      account: 'Account',
      rewards: 'Rewards',
      activity: 'Activity',
      more: 'More',
      guestTitle: "You're browsing as a guest",
      guestSubtitle: 'Sign in to book appointments, save favorites, and track your rewards.',
      signIn: 'Sign In',
      createAccount: 'Create Account',
      myProfile: 'My Profile',
      editProfile: 'Edit Profile',
      loyalty: 'Loyalty',
      referrals: 'Referrals',
      messages: 'Messages',
      myReviews: 'My Reviews',
      support: 'Support',
      settings: 'Settings',
      points: 'Points',
      visits: 'Visits',
      favorites: 'Favorites',
      quickActions: 'Quick Actions',
      activityHistory: 'Activity & Interactions',
      appearanceLanguage: 'Appearance & Language',
      viewPerks: 'View Perks',
      toNextTier: 'to reach',
      topTier: 'Top Tier Member',
      member: 'Member',
      joinSalunClub: 'Join SalunBD',
      guestPerk1: 'Earn reward points on every haircut',
      guestPerk2: '1-tap instant booking & queue tracking',
      guestPerk3: 'Exclusive member discounts and perks',
      versionText: 'Premium Grooming',
      logout: 'Log Out',
      logoutConfirmTitle: 'Log out?',
      logoutConfirmMessage: "You'll need to sign in again to book appointments.",
    },
    notifications: {
      title: 'Notifications',
      subtitle: 'Choose which alerts you want to get.',
      banner: 'Bookings, Promotions, and Reminders sync to your account. The rest are muted on this device.',
      alertsSection: 'Alerts',
      allow: 'Allow notifications',
      allowSub: 'Turn all app alerts on or off',
      bookings: 'Bookings',
      bookingsSub: 'Confirmations, reminders, and changes',
      promotions: 'Promotions',
      promotionsSub: 'Offers and discounts near you',
      loyalty: 'Loyalty',
      loyaltySub: 'Points earned and rewards',
      reminders: 'Reminders',
      remindersSub: 'Upcoming appointment reminders',
      system: 'System',
      systemSub: 'App updates and announcements',
    },
    auth: {
      signInTitle: 'Sign in to SalunBD',
      signInSub: 'Book appointments, track queues, and earn rewards',
      phoneOrEmail: 'Phone number or Email',
      password: 'Password',
      forgotPassword: 'Forgot Password?',
      signInBtn: 'Sign In',
      orContinue: 'Or continue with',
      googleSignIn: 'Continue with Google',
      noAccount: "Don't have an account?",
      createOne: 'Create one',
      guestContinue: 'Browse as Guest',
    },
  },
  bn: {
    common: {
      save: 'সেভ করুন',
      cancel: 'ক্যান্সেল',
      confirm: 'কনফার্ম করুন',
      loading: 'লোড হচ্ছে...',
      retry: 'আবার চেষ্টা করুন',
      back: 'ফিরে যান',
      done: 'কমপ্লিট',
      edit: 'এডিট',
      delete: 'ডিলিট করুন',
      selected: 'নির্বাচিত',
      seeAll: 'সব দেখুন',
      viewAll: 'সব দেখুন',
      search: 'সার্চ করুন',
      error: 'ত্রুটি',
      success: 'সফল',
      close: 'বন্ধ করুন',
      submit: 'জমা দিন',
      all: 'সব',
      status: 'অবস্থা',
      active: 'অ্যাক্টিভ',
      inactive: 'নিষ্ক্রিয়',
      call: 'কল করুন',
      share: 'শেয়ার করুন',
      refresh: 'রিফ্রেশ',
      details: 'বিস্তারিত',
      mins: 'মিনিট',
      today: 'আজকে',
      remove: 'ডিলিট করুন',
      apply: 'প্রয়োগ করুন',
      reset: 'রিসেট',
      bookNow: 'এখনই বুক করুন',
    },
    tabs: {
      home: 'হোম',
      discover: 'সার্চ করুন',
      bookings: 'বুকিং',
      favorites: 'পছন্দ',
      profile: 'প্রোফাইল',
    },
    home: {
      greetingMorning: 'শুভ সকাল',
      greetingAfternoon: 'শুভ অপরাহ্ন',
      greetingEvening: 'শুভ সন্ধ্যা',
      searchPlaceholder: 'সেলুন, স্টাইলিস্ট, হেয়ারকাট সার্চ করুন...',
      yourNextAppt: 'আপনার নেক্সট অ্যাপয়েন্টমেন্ট',
      yourUpcomingAppt: 'আপনার আপকামিং অ্যাপয়েন্টমেন্ট',
      moreAppts: 'টি আরও',
      inviteFriends: 'বন্ধুদের ইনভাইট করুন',
      inviteFriendsBadge: 'ইনভাইট অফার',
      inviteFriendsSub: 'SalunBD শেয়ার করুন যাতে আপনার বন্ধুরাও সহজে হেয়ারকাট ও বুকিং করতে পারে।',
      inviteFriendsBtn: 'ইনভাইট করুন',
      nearbyShops: 'নিকটবর্তী সেলুনসমূহ',
      findingSalons: 'নিকটবর্তী সেলুন খোঁজা হচ্ছে…',
      loadErrorTitle: 'সেলুন লোড করা যায়নি',
      loadErrorMsg: 'ইন্টারনেট কানেকশন পরীক্ষা করে আবার চেষ্টা করুন।',
      noShopsTitle: 'এখনও কোনো সেলুন নেই',
      noShopsMsg: 'শিগগিরই আরও নতুন সেলুন যুক্ত হবে।',
      nearbyNeedsLocation: 'কাছের শপ দেখুন',
      nearbyNeedsLocationMsg: 'জিজ্ঞেস করলে লোকেশনের পারমিশন দিন, অথবা উপরের লোকেশন বোতাম থেকে একটি জায়গা বেছে নিন।',
      noNearbyTitle: 'আপনার কাছে এখনও কোনো শপ নেই',
      noNearbyMsg: '২৫ কিমির মধ্যে এখনও কিছু নেই। তবুও সব শপ দেখতে পারেন।',
      howWasVisit: 'আপনার সার্ভিস কেমন ছিল?',
      timeToComeBack: 'আবার আসার সময় হয়েছে',
      bookAgain: 'আবার বুক করুন',
      unreadMessages: 'মেসেজসমূহ',
      unreadAlerts: 'নোটিফিকেশনসমূহ',
    },
    discover: {
      title: 'সেলুন সার্চ করুন',
      searchPlaceholder: 'সেলুন, সার্ভিস বা স্টাইলিস্ট সার্চ করুন...',
      quickFilterAll: 'সব সেলুন',
      quickFilterTopRated: 'টপ রেটেড (৪.৫★+)',
      quickFilterInstant: 'দ্রুত বুকিং',
      nearbyHeading: 'নিকটবর্তী সেলুন',
      enableLocation: 'লোকেশন চালু করুন',
      enableLocationSub: 'কাছের সেলুনগুলো দেখতে আপনার ডিভাইসের লোকেশন চালু করুন।',
      findingNearby: 'কাছের সেলুন খোঁজা হচ্ছে…',
      noNearbyTitle: 'কাছে কোনো সেলুন পাওয়া যায়নি',
      noNearbySub: 'অন্য লোকেশন বেছে নিন অথবা টপ রেটেড সেলুনগুলো দেখুন।',
      popularHeading: 'SalunBD-এ জনপ্রিয়',
      popularNearHeading: 'আপনার কাছে জনপ্রিয়',
      popularSub: 'এই মাসে সবচেয়ে ব্যস্ত ও ভালো রিভিউ পাওয়া',
      salonsHeading: 'সেলুন ও স্পা',
      loadingSalons: 'সেলুন ও স্পা লোড হচ্ছে…',
      salonsError: 'সেলুন ও স্পা লোড করা যায়নি',
      withinKm: 'আপনার থেকে {km} কিমির মধ্যে',
      closestToYou: 'আপনার সবচেয়ে কাছের আগে',
      closestTo: '{place} থেকে সবচেয়ে কাছের আগে',
      browseAll: 'সব শপ দেখুন',
      noNearbyWithin: 'এখনও কোনো শপ বা স্টাইলিস্ট নেই। নতুনরা SalunBD-তে যুক্ত হচ্ছে।',
      recommendedHeading: 'আপনার জন্য বাছাইকৃত',
      topStylistsHeading: 'টপ রেটেড স্টাইলিস্ট',
      offersHeading: 'অনগোয়িং অফার ও ডিসকাউন্ট',
      seeAll: 'সব দেখুন',
    },
    bookings: {
      title: 'আমার বুকিং',
      searchPlaceholder: 'সেলুন, স্টাইলিস্ট বা বুকিং কোড দিয়ে সার্চ করুন...',
      filterAll: 'সব',
      filterUpcoming: 'আপকামিং',
      filterCompleted: 'কমপ্লিট',
      filterCancelled: 'ক্যান্সেল',
      emptyUpcomingTitle: 'কোনো আপকামিং বুকিং নেই',
      emptyUpcomingSub: 'কয়েক ট্যাপেই আপনার নেক্সট গ্রুমিং অ্যাপয়েন্টমেন্ট বুক করুন।',
      emptyCompletedTitle: 'কোনো কমপ্লিট বুকিং নেই',
      emptyCompletedSub: 'আপনার অতীত সার্ভিস ও অ্যাপয়েন্টমেন্ট এখানে প্রদর্শিত হবে।',
      emptyCancelledTitle: 'কোনো ক্যান্সেল বুকিং নেই',
      emptyCancelledSub: 'আপনার কোনো ক্যান্সেলকৃত অ্যাপয়েন্টমেন্ট নেই।',
      emptyAllTitle: 'এখনও কোনো বুকিং নেই',
      emptyAllSub: 'সেরা সেলুনগুলো থেকে আপনার সুবিধামতো সময়ে বুকিং করুন।',
      bookNow: 'এখনই বুক করুন',
      cancelBooking: 'বুকিং ক্যান্সেল করুন',
      cancelConfirmTitle: 'বুকিং ক্যান্সেল করবেন?',
      cancelConfirmMsg: 'আপনি কি নিশ্চিত যে এই অ্যাপয়েন্টমেন্টটি ক্যান্সেল করতে চান?',
      reschedule: 'সময় পুনঃনির্ধারণ',
      viewShop: 'সেলুন দেখুন',
      statusUpcoming: 'আপকামিং',
      statusCompleted: 'কমপ্লিট',
      statusCancelled: 'ক্যান্সেল',
      statusInQueue: 'সিরিয়ালে আছেন',
      statusInChair: 'চেয়ারে সার্ভিস চলছে',
      bookingCode: 'বুকিং কোড',
    },
    favorites: {
      title: 'ফেভারিট লিস্ট',
      shopsTab: 'সেলুনসমূহ',
      stylistsTab: 'স্টাইলিস্টবৃন্দ',
      emptyShopsTitle: 'ফেভারিট কোনো সেলুন নেই',
      emptyShopsSub: 'হার্ট আইকনে চাপ দিয়ে দ্রুত বুকিংয়ের জন্য সেলুন সেভ করুন।',
      emptyStylistsTitle: 'ফেভারিট কোনো স্টাইলিস্ট নেই',
      emptyStylistsSub: 'ফেভারিট স্টাইলিস্টদের সেভ করে রাখুন যাতে সহজে খুঁজে পান।',
      exploreShops: 'সেলুন সার্চ করুন',
      loadingShop: 'সেলুন লোড হচ্ছে…',
      loadingStylist: 'স্টাইলিস্ট লোড হচ্ছে…',
      errorShop: 'সেলুন তথ্য লোড করা যায়নি',
      errorStylist: 'স্টাইলিস্ট তথ্য লোড করা যায়নি',
    },
    loyalty: {
      title: 'রিওয়ার্ডস ও লয়্যালটি',
      points: 'পয়েন্ট',
      tierMember: 'মেম্বার',
      tierSilver: 'সিলভার',
      tierGold: 'গোল্ড',
      tierPlatinum: 'প্লাটিনাম',
      perksTitle: 'আপনার সুবিধাসমূহ',
      historyTitle: 'পয়েন্ট হিস্ট্রি',
      currentTier: 'কারেন্ট স্তর',
      activities: 'কার্যক্রম',
      howToEarn: 'পয়েন্ট অর্জনের উপায়',
      bookAnyService: 'যেকোনো সার্ভিস বুক করুন',
      emptyActivityTitle: 'এখনও কোনো পয়েন্ট লেনদেন নেই',
      emptyActivitySub: 'পয়েন্ট পেতে সার্ভিস বুক করুন অথবা বন্ধুদের ইনভাইট করুন!',
      loading: 'লয়ালটি প্রোগ্রাম লোড হচ্ছে…',
      loadError: 'রিওয়ার্ড তথ্য লোড করা যায়নি',
    },
    services: {
      haircut: 'হেয়ারকাট',
      beard: 'দাড়ি ছাঁটা',
      facial: 'ফেসিয়াল ও স্পা',
      color: 'হেয়ার কালার',
      styling: 'হেয়ার স্টাইলিং',
    },
    settings: {
      title: 'সেটিংস',
      preferences: 'পছন্দসমূহ',
      notifications: 'নোটিফিকেশন (Notifications)',
      notificationsSubtitle: 'কোন অ্যালার্টগুলো পাবেন তা বেছে নিন',
      appearance: 'থিম ও ভাষা (Appearance)',
      appearanceSubtitle: 'থিম ও অ্যাপ্লিকেশনের ভাষা',
      security: 'সিকিউরিটি ও প্রাইভেসি',
      securitySubtitle: 'পাসওয়ার্ড, বায়োমেট্রিক সাইন-ইন এবং ডিভাইস',
      support: 'সাহায্য ও সাপোর্ট',
      supportSubtitle: 'জিজ্ঞাসিত প্রশ্ন, কাস্টমার সাপোর্ট ও টিকিট',
      privacyPolicy: 'প্রাইভেসি পলিসি (Privacy Policy)',
      privacyPolicySubtitle: 'SalunBD কীভাবে আপনার ডেটা পরিচালনা করে',
      termsOfService: 'ব্যবহারের শর্তাবলী (Terms of Service)',
      termsOfServiceSubtitle: 'SalunBD ব্যবহারের নির্দেশিকা ও নিয়মাবলী',
    },
    appearance: {
      title: 'থিম ও ভাষা',
      subtitle: 'এই ডিভাইসে SalunBD কাস্টমাইজ করুন।',
      themeSection: 'থিম (Theme)',
      useDevice: 'ডিভাইস সেটিংস ব্যবহার করুন',
      useDeviceSub: 'ফোনের সাধারণ থিম অনুসরণ করুন',
      light: 'লাইট (Light)',
      lightSub: 'উজ্জ্বল ইন্টারফেস',
      dark: 'ডার্ক (Dark)',
      darkSub: 'চোখের জন্য আরামদায়ক অন্ধকার মোড',
      languageSection: 'ভাষা (Language)',
      english: 'English',
      englishSub: 'অ্যাপের ভাষা',
      bangla: 'বাংলা',
      banglaSub: 'অ্যাপ্লিকেশনের ভাষা',
      banner: 'আপনার ভাষা নির্বাচন সেভড হয়েছে। এটি তাৎক্ষণিকভাবে পরিবর্তিত হবে।',
    },
    profile: {
      account: 'অ্যাকাউন্ট',
      rewards: 'রিওয়ার্ডস',
      activity: 'কার্যকলাপ',
      more: 'অন্যান্য',
      guestTitle: 'আপনি গেস্ট হিসেবে ব্রাউজ করছেন',
      guestSubtitle: 'অ্যাপয়েন্টমেন্ট বুক করতে, পছন্দ সেভ করতে এবং রিওয়ার্ড ট্র্যাক করতে সাইন ইন করুন।',
      signIn: 'সাইন ইন',
      createAccount: 'অ্যাকাউন্ট তৈরি করুন',
      myProfile: 'আমার প্রোফাইল',
      editProfile: 'প্রোফাইল এডিট',
      loyalty: 'লয়্যালটি পয়েন্টস',
      referrals: 'রেফারেল',
      messages: 'মেসেজ',
      myReviews: 'আমার রিভিউ',
      support: 'সাহায্য কেন্দ্র (Support)',
      settings: 'সেটিংস',
      points: 'পয়েন্টস',
      visits: 'ভিজিট',
      favorites: 'পছন্দসমূহ',
      quickActions: 'কুইক অ্যাকশন',
      activityHistory: 'কার্যকলাপ ও মতামত',
      appearanceLanguage: 'থিম ও ভাষা',
      viewPerks: 'সুবিধাসমূহ দেখুন',
      toNextTier: 'নেক্সট লেভেলে পৌঁছাতে',
      topTier: 'ম্যাক্সিমাম টিয়ার মেম্বার',
      member: 'মেম্বার',
      joinSalunClub: 'SalunBD-তে জয়েন করুন',
      guestPerk1: 'প্রতিটি হেয়ারকাট ও সার্ভিসে পয়েন্ট অর্জন করুন',
      guestPerk2: '১-ট্যাপ দ্রুত বুকিং ও লাইভ কিউ ট্র্যাকিং',
      guestPerk3: 'বিশেষ মেম্বার ডিসকাউন্ট এবং এক্সক্লুসিভ অফার',
      versionText: 'প্রিমিয়াম গ্রুমিং',
      logout: 'লগআউট',
      logoutConfirmTitle: 'লগআউট করবেন?',
      logoutConfirmMessage: 'অ্যাপয়েন্টমেন্ট বুক করতে আপনাকে আবার সাইন ইন করতে হবে।',
    },
    notifications: {
      title: 'নোটিফিকেশন ও অ্যালার্ট',
      subtitle: 'কোন সতর্কতাগুলো পেতে চান তা বেছে নিন।',
      banner: 'বুকিং, অফার ও রিমাইন্ডার আপনার অ্যাকাউন্টে সিঙ্ক থাকে। বাকিগুলো এই ফোনে সেভড।',
      alertsSection: 'অ্যালার্ট সেটিংস',
      allow: 'নোটিফিকেশন চালু রাখুন',
      allowSub: 'অ্যাপের সব সতর্কতা চালু বা বন্ধ করুন',
      bookings: 'বুকিং',
      bookingsSub: 'নিশ্চিতকরণ, রিমাইন্ডার এবং চেঞ্জ',
      promotions: 'অফার ও প্রমোশন',
      promotionsSub: 'আপনার কাছাকাছি অফার ও ছাড়',
      loyalty: 'লয়্যালটি',
      loyaltySub: 'অর্জিত পয়েন্ট ও পুরস্কার',
      reminders: 'রিমাইন্ডার',
      remindersSub: 'আপকামিং অ্যাপয়েন্টমেন্ট রিমাইন্ডার',
      system: 'সিস্টেম',
      systemSub: 'অ্যাপ আপডেট এবং ঘোষণা',
    },
    auth: {
      signInTitle: 'SalunBD তে সাইন ইন করুন',
      signInSub: 'অ্যাপয়েন্টমেন্ট বুক করতে এবং পয়েন্ট পেতে অ্যাকাউন্টে প্রবেশ করুন',
      phoneOrEmail: 'ফোন নম্বর অথবা ইমেইল',
      password: 'পাসওয়ার্ড',
      forgotPassword: 'পাসওয়ার্ড মনে নেই?',
      signInBtn: 'সাইন ইন',
      orContinue: 'অথবা এর মাধ্যমে এগিয়ে যান',
      googleSignIn: 'গুগল দিয়ে সাইন ইন',
      noAccount: 'অ্যাকাউন্ট নেই?',
      createOne: 'নতুন তৈরি করুন',
      guestContinue: 'গেস্ট হিসেবে ব্রাউজ করুন',
    },
  },
} as const;

export type Translations = typeof translations.en;
export type TranslationSection = keyof Translations;
